import { render, staticRenderFns } from "./CertificateDetails.vue?vue&type=template&id=57f29e51&scoped=true&"
import script from "./CertificateDetails.vue?vue&type=script&lang=ts&"
export * from "./CertificateDetails.vue?vue&type=script&lang=ts&"
import style0 from "./CertificateDetails.vue?vue&type=style&index=0&id=57f29e51&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f29e51",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
